import {
	isSchemaComponent,
	isSchemaConstAny,
	isSchemaConstArray,
	isSchemaConstBoolean,
	isSchemaConstData,
	isSchemaConstEnum,
	isSchemaConstFloat,
	isSchemaConstInteger,
	isSchemaConstMap,
	isSchemaConstObject,
	isSchemaConstPassword,
	isSchemaConstSecret,
	isSchemaConstString,
	isSchemaDataSource,
	isSchemaExpression,
	isSchemaFlowNode,
	isSchemaFlowNodeList,
	isSchemaIconName,
	isSchemaIntegrationRef,
	isSchemaOneOf,
	isSchemaOptGroup,
	isSchemaRecursive,
	isSchemaResponsiveValue,
	isSchemaRouteRef,
	isSchemaScopedTemplate,
	isSchemaStringTranslate,
	isSchemaStringWithConst,
	isSchemaValue,
	isSchemaViewRef,
	TGenericBlueprintSchema
} from "@adapptio/lib-blueprint";
import { getTypeFromSchema } from "../helpers/getTypeFromSchema";
import { mapperDescriptor } from "./mapperDescriptor";
import { mapperExamples } from "./mapperExamples";

export const mapperChild = (schema: TGenericBlueprintSchema) => {
	if (isSchemaFlowNodeList(schema)) console.log("isSchemaFlowNodeList", schema);
	if (isSchemaFlowNode(schema)) console.log("isSchemaFlowNode", schema);
	if (isSchemaDataSource(schema)) console.log("isSchemaDataSource", schema);
	if (isSchemaStringTranslate(schema)) console.log("StringTranslate", schema);
	if (isSchemaComponent(schema)) console.log("Component", schema);
	if (isSchemaRouteRef(schema)) console.log("isSchemaRouteRef", schema);

	if (isSchemaIntegrationRef(schema)) {
		// console.log('isSchemaIntegrationRef', schema)
		return;
	}

	if (isSchemaConstPassword(schema)) {
		const opts = schema.opts;
		return {
			label: opts.label,
			description: opts.description,
			required: opts.constraints?.required || null,
			descriptor: mapperDescriptor(schema),
			examples: mapperExamples(schema),
			type: getTypeFromSchema(schema)
		};
	}

	if (isSchemaConstSecret(schema)) {
		const opts = schema.opts;
		return {
			label: opts.label,
			description: opts.description,
			required: opts.constraints?.required || null,
			descriptor: mapperDescriptor(schema),
			examples: mapperExamples(schema),
			type: getTypeFromSchema(schema)
		};
	}

	if (isSchemaConstMap(schema)) {
		const opts = schema.opts;
		if (opts.label) {
			return {
				label: opts.label,
				description: opts.description,
				required: opts.constraints?.required || null,
				descriptor: mapperDescriptor(schema),
				examples: mapperExamples(schema),
				type: getTypeFromSchema(schema)
			};
		} else {
			return mapperChild(opts.value);
		}
	}

	if (isSchemaExpression(schema)) {
		const opts = schema.opts;
		return {
			label: opts.label,
			description: opts.description,
			defaultValue: JSON.stringify(opts.default),
			examples: mapperExamples(schema),
			descriptor: mapperDescriptor(schema)
		};
	}

	if (isSchemaScopedTemplate(schema)) {
		const opts = schema.opts;
		return {
			label: opts.label,
			description: opts.description,
			examples: mapperExamples(schema),
			descriptor: mapperDescriptor(schema)
		};
	}

	if (isSchemaConstFloat(schema)) {
		const opts = schema.opts;
		return {
			label: opts.label,
			description: opts.description,
			defaultValue: JSON.stringify(opts.default),
			descriptor: mapperDescriptor(schema),
			required: opts.constraints?.required || null,
			examples: mapperExamples(schema),
			type: getTypeFromSchema(schema)
		};
	}

	if (isSchemaIconName(schema)) {
		const opts = schema.opts;
		return {
			label: opts.label,
			description: opts.description,
			defaultValue: JSON.stringify(opts.default),
			descriptor: mapperDescriptor(schema),
			examples: mapperExamples(schema),
			required: opts.constraints?.required || null,
			type: getTypeFromSchema(schema)
		};
	}

	if (isSchemaRecursive(schema)) {
		return;
	}

	if (isSchemaConstAny(schema)) {
		const opts = schema.opts;
		return {
			label: opts.label,
			description: opts.description,
			defaultValue: JSON.stringify(opts.defaultType),
			descriptor: mapperDescriptor(schema),
			required: opts.constraints?.required || null,
			examples: mapperExamples(schema),
			type: getTypeFromSchema(schema)
		};
	}

	if (isSchemaConstData(schema)) {
		const opts = schema.opts;
		return {
			label: opts.label,
			description: opts.description,
			defaultValue: JSON.stringify(opts.defaultType),
			descriptor: mapperDescriptor(schema),
			required: opts.constraints?.required || null,
			examples: mapperExamples(schema),
			type: getTypeFromSchema(schema)
		};
	}

	if (isSchemaViewRef(schema)) {
		const opts = schema.opts;
		return {
			label: opts.label,
			description: opts.description,
			required: opts.constraints?.required || null,
			descriptor: mapperDescriptor(schema),
			examples: mapperExamples(schema),
			type: getTypeFromSchema(schema)
		};
	}

	if (isSchemaStringWithConst(schema)) {
		const opts = schema.opts;
		return {
			label: opts.label,
			description: opts.description,
			defaultValue: JSON.stringify(opts.default),
			required: opts.constraints?.required || null,
			example: opts.example,
			constants: opts.constants,
			examples: mapperExamples(schema),
			descriptor: mapperDescriptor(schema),
			type: getTypeFromSchema(schema)
		};
	}

	if (isSchemaResponsiveValue(schema)) {
		const opts = schema.opts;
		return {
			label: opts.label,
			description: opts.description,
			child: [ mapperChild(opts.value) ],
			descriptor: mapperDescriptor(schema),
			required: opts.constraints?.required || null,
			examples: mapperExamples(schema),
			type: getTypeFromSchema(schema)
		};
	}

	if (isSchemaOptGroup(schema)) {
		const opts = schema.opts;
		const obj = {
			label: opts.label,
			description: opts.description,
			type: getTypeFromSchema(schema),
			descriptor: mapperDescriptor(schema),
			required: opts["constraints"]?.required || null,
			examples: mapperExamples(schema),
			child: mapperChild(opts["value"])
		};

		if (obj.child?.type === "Object" && !obj.child?.label) {
			obj.child = obj.child.child;
		}

		return obj;
	}

	if (isSchemaOneOf(schema)) {
		const opts = schema.opts;
		return {
			label: opts.label,
			description: opts.description,
			defaultValue: JSON.stringify(opts.defaultType),
			descriptor: mapperDescriptor(schema),
			required: opts.constraints?.required || null,
			examples: mapperExamples(schema),
			type: getTypeFromSchema(schema)
		};
	}

	if (isSchemaConstArray(schema)) {
		const opts = schema.opts;
		return {
			label: opts.label,
			description: opts.description,
			required: opts.constraints?.required || null,
			child: mapperChild(opts.items),
			descriptor: mapperDescriptor(schema),
			examples: mapperExamples(schema),
			type: getTypeFromSchema(schema)
		};
	}

	if (isSchemaConstInteger(schema)) {
		const opts = schema.opts;
		return {
			label: opts.label,
			description: opts.description,
			required: opts.constraints?.required || null,
			descriptor: mapperDescriptor(schema),
			examples: mapperExamples(schema),
			defaultValue: JSON.stringify(opts.default),
			type: getTypeFromSchema(schema)
		};
	}

	if (isSchemaConstEnum(schema)) {
		const opts = schema.opts;
		return {
			label: opts.label,
			description: opts.description,
			required: opts.constraints?.required || null,
			descriptor: mapperDescriptor(schema),
			examples: mapperExamples(schema),
			defaultValue: JSON.stringify(opts["default"]),
			options: opts.options,
			type: getTypeFromSchema(schema)
		};
	}

	if (isSchemaConstBoolean(schema)) {
		const opts = schema.opts;
		return {
			label: opts.label,
			description: opts.description,
			defaultValue: JSON.stringify(opts.default),
			required: opts.constraints?.required || null,
			descriptor: mapperDescriptor(schema),
			examples: mapperExamples(schema),
			hidden: opts.hidden,
			type: getTypeFromSchema(schema)
		};
	}

	if (isSchemaConstString(schema)) {
		const opts = schema.opts;
		if (opts.label) {
			return {
				label: opts.label,
				description: opts.description,
				descriptor: mapperDescriptor(schema),
				required: opts.constraints?.required || null,
				examples: mapperExamples(schema),
				defaultValue: JSON.stringify(opts.default),
				type: getTypeFromSchema(schema)
			};
		}

		return;
	}

	if (isSchemaValue(schema)) {
		return mapperChild(schema.constSchema);
	}

	if (isSchemaConstObject(schema)) {
		const opts = schema.opts;
		const child = opts.props;

		if (opts.label) {
			return {
				label: opts.label,
				description: opts.description,
				required: opts.constraints?.required || null,
				hidden: opts.hidden,
				descriptor: mapperDescriptor(schema),
				examples: mapperExamples(schema),
				// category: REFERENCE_TYPE.COMPONETS,
				type: getTypeFromSchema(schema),
				child: Object.keys(child).map((key) => mapperChild(child[key].schema))
			};
		} else {
			return Object.keys(child).map((key) => mapperChild(child[key].schema));
		}
	}
};
